<template>
  <div class="more-panel-wrap">
    <upModel
      :show="value"
      @close="close"
      :showCloseBtn="false"
      :autoHeight="true"
      class="hp-more-panel"
    >
      <div class="hp-more-panel-model" ref="moreModel">
        <div class="hp-more-panel-inner">
          <div class="more-title">
            <p class="author-name">{{ basicInfo.nickname }}</p>
            <p class="more-id">ID：{{ authorUserId }}</p>
            <p class="more-copy-btn" @click="copyUserId">复制</p>
          </div>
          <ul class="more-item-wrap">
            <li
              class="more-item"
              v-for="(item, index) in items"
              :key="index"
              @click="item.callback(item)"
            >
              <div class="more-item-t">
                <img :src="item.icon" alt="" />
              </div>
              <div class="more-item-b">{{ item.title }}</div>
            </li>
          </ul>
        </div>
        <div class="more-line"></div>
        <div class="more-btn" @click="close">取消</div>
      </div>
    </upModel>
    <!-- 举报弹窗 -->
    <reportPopup
      v-if="selectReport"
      @confirm="confirmReport"
      @cancelR="selectReport = false"
    />
  </div>
</template>

<script>
import upModel from 'lib/component/vue/upModel/upModel.vue'
import { copyStr } from 'lib/component/wxToAPP/appCommand'
import { Dialog } from 'vant'
import reportPopup from 'component/platform/reportPopup.vue'
import { setReport } from 'api/platform/topicDetail'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
import { postBlock } from 'api/platform/homepage.js'
import preventScrollChain from 'utils/preventScrollChain.js'

export default {
  mixins: [homepageMixin],
  components: {
    reportPopup,
    upModel
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectReport: false
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
    loginUser() {
      return this.$store.getters['loginUser']
    },
    isOwner() {
      return +this.loginUser.id === +this.$route.params.userId
    },
    authorUserId() {
      return this.$route.params.userId || ''
    },
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },

    userRelation() {
      return this.$store.state.homepage.userRelation
    },

    items() {
      const list = [
        {
          title: '拉黑ta',
          icon: require('images/platform/homepage/more-btn-block.png'),
          hide: this.isOwner || +this.userRelation.in_own_blacklist === 1, // 已被自己拉黑
          callback: () => {
            this.toggleFriend('add')
          }
        },
        {
          title: '移出黑名单',
          icon: require('images/platform/homepage/more-btn-unblock.png'),
          hide: this.isOwner || +this.userRelation.in_own_blacklist !== 1, // 未被自己拉黑
          callback: () => {
            this.toggleFriend('remove')
          }
        },
        {
          title: '举报ta',
          icon: require('images/platform/homepage/more-btn-report.png'),
          hide: this.isOwner,
          callback: this.handleReport
        },
        {
          title: '编辑资料',
          icon: require('images/platform/homepage/more-btn-edit.png'),
          hide: !this.isOwner,
          callback: () => {
            this.$emit('edit')
          }
        }
      ]
      return list.filter(item => !item.hide)
    }
  },
  watch: {
    value(val) {
      this.$nextTick(() => {
        if (!!val) {
          preventScrollChain(this.$refs.moreModel)
        } else {
          preventScrollChain.destory()
        }
      })
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    copyUserId() {
      this.$trackEvent('newprofilepages_more_copyid', {})
      copyStr(this.authorUserId)
      this.$toast({
        text: '复制成功',
        zIndexTop: true
      })
    },
    // 拉黑 or 取消拉黑
    async toggleFriend(action) {
      await this.$store.dispatch('getUserInfo')
      if (!this.isLogin) {
        this.toLogin()
        return
      }
      if (this.isOwner) {
        this.$toast({
          text: '不能对自己进行该操作',
          zIndexTop: true
        })
        return
      }

      if (action === 'add') {
        // 拉黑
        Dialog.confirm({
          title: '确定拉黑该用户？',
          message: '拉黑后，ta将无法关注你，也无法与你互动。',
          className: 'homepage-vant-dialog-style-v2',
          confirmButtonText: '暂不拉黑',
          cancelButtonText: '确认拉黑'
        })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            this._toggleFriend('add')
          })
      } else {
        // 取消拉黑
        this._toggleFriend('remove')
      }
    },
    _toggleFriend(action) {
      if (this.blocking) return
      this.blocking = true

      const tips = {
        success: action === 'add' ? '加入' : '移出',
        fail: action === 'add' ? '拉黑' : '取消拉黑'
      }

      this.mixinGetToken()
        .then(token => {
          return postBlock({
            action,
            black_user_id: this.authorUserId,
            token
          })
        })
        .then(({ code, message }) => {
          if (+code === 0) {
            this.$toast({
              text: `已将其${tips.success}黑名单`,
              zIndexTop: true
            })
            if (action === 'add') {
              // 埋点
              this.$trackEvent('newprofilepages_more_block', {})
            }
            // 更新状态
            this.$store.dispatch('homepage/fetchUserRelation', {
              user_id: this.authorUserId
            })
            // 如果已关注，拉黑后需自动取消关注
            if (+this.userRelation.follow === 1 && action === 'add') {
              this.$emit('follow', true)
            }
          } else {
            this.$toast({
              text: message || `${tips.fail}失败`,
              zIndexTop: true
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$toast({
            text: `${tips.fail}失败，请稍后重试`,
            zIndexTop: true
          })
        })
        .finally(() => {
          this.blocking = false
        })
    },
    // 举报
    async handleReport() {
      await this.$store.dispatch('getUserInfo')
      if (this.isOwner) {
        this.$toast({
          text: '不能对自己进行该操作',
          zIndexTop: true
        })
        return
      }
      this.selectReport = true
    },
    // 确认举报
    confirmReport(reportReason) {
      if (!reportReason) return
      this.mixinGetToken()
        .then(token => {
          let params = {
            objectType: 10, //对象类型，1=动态，2=文章，3=回答，4=直播，5=提问，6=FM节目，7=短视频，8=话题，9=群聊，10=用户，11=私信用户
            objectId: this.authorUserId, //内容id
            reportReason, // 举报原因，1-不当言论，2-刷赞嫌疑，3-抄袭，99-其它
            token
          }
          return setReport(params)
        })
        .then(res => {
          const { code, message } = res
          if (code == 0) {
            this.$toast({
              text: '举报成功',
              zIndexTop: true
            })
            // 埋点
            this.$trackEvent('newprofilepages_more_report', {})
          } else {
            this.$toast({
              text: message,
              zIndexTop: true
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$toast({
            text: '网络异常，请重试',
            zIndexTop: true
          })
        })
        .finally(() => {
          this.selectReport = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';

.hp-more-panel-model {
  padding: 58px 0 44px 0;
  box-sizing: border-box;
  .hp-more-panel-inner {
    padding: 0 32px;
  }
  .more-title {
    display: flex;
    align-items: center;
    .author-name {
      font-size: 38px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #21252d;
      @include limitLine(2);
    }
    .more-id {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      margin-left: 20px;
      margin-right: 20px;
      white-space: nowrap;
    }
    .more-copy-btn {
      width: 66px;
      height: 32px;
      border-radius: 10px;
      border: 1px solid #eaeaea;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c798c;
      flex-shrink: 0;
    }
  }
  .more-item-wrap {
    display: flex;
    align-items: center;
    margin-top: 50px;
    .more-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 40px;
    }
    .more-item-t {
      width: 100px;
      height: 100px;
      background: rgba(234, 234, 234, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-bottom: 16px;
      img {
        width: 36px;
        height: 36px;
        object-fit: cover;
      }
    }
    .more-item-b {
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9da3ac;
    }
  }
  .more-line {
    width: 100%;
    height: 8px;
    background: #f3f4f5;
    margin: 40px auto;
  }
  .more-btn {
    width: 100%;
    background-color: #fff;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #9da3ac;
    text-align: center;
  }
}
</style>
